import React, { useState, useCallback, useEffect } from "react";
import "./organization-access-list-create-edit.scss";

import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMatch } from "react-router-dom";
import { selectCurrentOrganization } from "../../reducers/organizationSlice";

import { accessListForm } from "../../forms/AccessListForm";
import {
  selectAccessListNotifications,
  selectCurrentList,
  getOrganizationAccessList,
  saveAccessList,
  createAccessList,
  clearNotifications,
  setSelectedList,
} from "../../reducers/accessSlice";

const OrganizationAccessListCreateEdit = () => {
  const [isValid, setIsValid] = useState(false);

  const [list, setList] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matchEdit = useMatch("/:id/access/:accessListID/*");
  const orgNotifications = useSelector(selectAccessListNotifications);
  const currentOrganization = useSelector(selectCurrentOrganization);
  const currentList = useSelector(selectCurrentList);

  const loadList = useCallback(() => {
    if (matchEdit?.params?.accessListID !== "add") {
      dispatch(getOrganizationAccessList(matchEdit?.params?.accessListID));
    } else {
      const newList = {
        name: "",
        description: "",
        status: "active",
      };
      setList(newList);
    }
  }, [dispatch, matchEdit?.params]);

  useEffect(() => {
    loadList();
    return () => {
      dispatch(setSelectedList({}));
    };
  }, [loadList, dispatch]);

  useEffect(() => {
    const { id, accessListID } = matchEdit?.params;
    if (currentList?.id) {
      if (currentList?.id !== accessListID) {
        navigate(`/${id}/access/${currentList.id}/edit`);
      } else {
        setList(currentList);
      }
    } else {
      const newList = {
        name: "",
        description: "",
        status: "active",
      };
      setList(newList);
    }
  }, [currentList, matchEdit?.params, navigate]);

  //form context
  let context = {};

  context.validationFailed = () => {
    if (isValid) {
      setIsValid(false);
    }
  };

  context.updateList = (value, property) => {
    setIsValid(true);
    let group = { ...list };
    group[property] = value;
    setList(group);
  };

  context.isEditable = () => {
    return matchEdit?.params?.accessListID === "add";
  };

  const saveList = () => {
    setIsValid(false);
    let save = { ...list };
    save.organization = currentOrganization;
    dispatch(saveAccessList(save));
  };

  const addList = () => {
    setIsValid(false);
    let create = { ...list };
    create.organization = currentOrganization;
    dispatch(createAccessList(create));
  };

  const deleteList = () => {
    const { id, accessListID } = matchEdit.params;
    navigate(`/${id}/access/${accessListID}/delete`);
  };

  const leftNavigation = () => {
    dispatch(clearNotifications());
    const { id, accessListID } = matchEdit?.params;
    if(accessListID !== "add")
    {
      navigate(`/${id}/access/${accessListID}`)
    }
    else{
      navigate(`/${id}/access`)
    }
    
    //navigate(-1);
  };

  const getActions = () => {
    let actions = [{ name: "cancel", action: leftNavigation, type: "grey" }];

    if (context?.isEditable?.()) {
      actions.unshift?.({
        name: "Save",
        isDisabled: !isValid,
        action: addList,
        type: "black",
      });
    } else {
      actions?.unshift?.({
        name: "Save",
        isDisabled: !isValid,
        action: saveList,
        type: "black",
      });
      actions?.push?.({
        name: "Delete List",
        action: deleteList,
        type: "transparent red",
      });
    }
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Access List Details",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    const slideOutNotifications = orgNotifications;
    if (hasNotifications(slideOutNotifications)) {
      return {
        notifications: slideOutNotifications.map((n) => ({
          ...n,
          pageActions: getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "View Access Codes",
        size: "secondary",
        actionClick: leftNavigation,
      },
    ];
  };

  const getActiveAction = () => {
    return [
      {
        actionType: "toggle",
        value: true,
        pageActionProps: {
          falseDescription: "Inactive",
          rowReverse: true,
          onClick: (e) =>
            context.updateList(
              list?.status === "active" ? "inactive" : "active",
              "status"
            ),
          trueDescription: "Active",
          value: list?.status === "active",
        },
      },
    ];
  };

  const getFormActionBar = () => {
    return {
      formTitle: context.isEditable()
        ? "Add Access List"
        : "Edit Access List",
      formActions: getActiveAction(),
    };
  };

  const getContent = () => {
    return (
      <GSForm
        {...getFormActionBar()}
        formSections={accessListForm(context, list)}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };
  return (
    <organization-access-list-create-edit>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </organization-access-list-create-edit>
  );
};

export default OrganizationAccessListCreateEdit;
